import { render, staticRenderFns } from "./task-list-menu.vue?vue&type=template&id=cf869760&"
import script from "./task-list-menu.vue?vue&type=script&lang=js&"
export * from "./task-list-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports